var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.379,
    height: 19.884,
    viewBox: "0 0 14.379 19.884",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9061",
    "data-name": "Group 9061",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "notification-bell"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_916",
    "data-name": "Path 916",
    d: "M62.106,7.2v5.928a1.326,1.326,0,0,1-.391.944A2.425,2.425,0,0,0,61,15.8v.877h4.48a2.765,2.765,0,0,0,5.419,0h4.48V15.8a2.425,2.425,0,0,0-.715-1.726,1.326,1.326,0,0,1-.391-.944V7.2a5.9,5.9,0,0,0-5.307-6.058V-1H67.636V1.139A6.091,6.091,0,0,0,62.106,7.2Zm6.083,10.581a1.662,1.662,0,0,1-1.564-1.106h3.128A1.661,1.661,0,0,1,68.189,17.778ZM73.167,7.2l-.255,6.165a1.963,1.963,0,0,0,.757,1.49c.2.2.558.208.6.477H62.106c.046-.27.45-.28.647-.477a2.439,2.439,0,0,0,.729-1.726V7.2a4.48,4.48,0,0,1,4.708-4.64A4.706,4.706,0,0,1,73.167,7.2Z",
    transform: "translate(-61 1)",
    fill: "#2b2a2c"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_917",
    "data-name": "Path 917",
    d: "M-1477.106,3763.992h3.942l-.7,1.761h-2.224Z",
    transform: "translate(1482.281 -3746.684)",
    fill: "#2b2a2c"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.ad3135c8f1b4a658526260af4cc12c49.svg";
export { ForwardRef as ReactComponent };